import { useEffect, useState } from "react"
import { useMeetingPlayer } from "../../MeetingSummary/MeetingPlayerContext"
import { MiniPlayerView } from "../MiniPlayerView"
import type { IProps } from "./interfaces"

const SPEEDS = [0.5, 0.75, 1, 1.25, 1.5, 2] as const

function nextSpeed(current: number): number {
  const index = SPEEDS.findIndex((speed) => Math.abs(speed - current) < 0.01)
  const following = SPEEDS[(index + 1) % SPEEDS.length]
  return following ?? 1
}

/**
 * Smart dock. Reads the shared meeting player and keeps the clock locally so
 * playback ticks do not re-render the summary.
 */
export function MiniPlayer({ onExpand }: IProps): React.JSX.Element | null {
  const player = useMeetingPlayer()
  const [currentTime, setCurrentTime] = useState(0)
  const [duration, setDuration] = useState(0)

  const { subscribeProgress } = player

  useEffect(() => {
    if (!subscribeProgress) return undefined
    return subscribeProgress((time, length) => {
      setCurrentTime(time)
      setDuration(length)
    })
  }, [subscribeProgress])

  if (!player.available) return null

  const speed = player.speed ?? 1

  return (
    <MiniPlayerView
      playing={player.playing}
      currentTime={currentTime}
      duration={duration}
      speed={speed}
      onPlay={() => player.resume?.()}
      onPause={() => player.pause()}
      onSpeed={() => player.setSpeed?.(nextSpeed(speed))}
      onExpand={onExpand}
    />
  )
}
